import { render, staticRenderFns } from "./ChronologyNotification.vue?vue&type=template&id=060091c0&scoped=true&"
import script from "./ChronologyNotification.vue?vue&type=script&lang=js&"
export * from "./ChronologyNotification.vue?vue&type=script&lang=js&"
import style0 from "./ChronologyNotification.vue?vue&type=style&index=0&id=060091c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060091c0",
  null
  
)

export default component.exports